import { create } from "zustand";

export type OnboardingStatus = "pending" | "in-progress" | "completed" | "skipped";
export interface OnboardingState { version: 1; status: OnboardingStatus; lastStep: number; updatedAt: number }
const KEY = "mh-rp-onboarding-v1";

function load(): OnboardingState {
  try {
    const value = JSON.parse(localStorage.getItem(KEY) ?? "null") as Partial<OnboardingState> | null;
    if (value?.version === 1 && ["pending", "in-progress", "completed", "skipped"].includes(value.status ?? "")) return { version: 1, status: value.status!, lastStep: Math.min(4, Math.max(0, value.lastStep ?? 0)), updatedAt: value.updatedAt ?? Date.now() };
  } catch { /* reset malformed local metadata */ }
  return { version: 1, status: "pending", lastStep: 0, updatedAt: Date.now() };
}

interface Store extends OnboardingState {
  start: (reset?: boolean) => void;
  go: (step: number) => void;
  complete: () => void;
  skip: () => void;
}
function save(state: OnboardingState) { localStorage.setItem(KEY, JSON.stringify(state)); }
export const useOnboardingStore = create<Store>((set) => ({
  ...load(),
  start: (reset = false) => set((state) => { const next: OnboardingState = { version: 1, status: "in-progress", lastStep: reset ? 0 : state.lastStep, updatedAt: Date.now() }; save(next); return next; }),
  go: (step) => set(() => { const next: OnboardingState = { version: 1, status: "in-progress", lastStep: Math.min(4, Math.max(0, step)), updatedAt: Date.now() }; save(next); return next; }),
  complete: () => set((state) => { const next: OnboardingState = { version: 1, status: "completed", lastStep: 4, updatedAt: Date.now() }; save(next); return next; }),
  skip: () => set((state) => { const next: OnboardingState = { version: 1, status: "skipped", lastStep: state.lastStep, updatedAt: Date.now() }; save(next); return next; }),
}));
